<template>
  <div class="live-wrapper" :class="liveClass">
    <app-bar :data-id="pid" data-type="21"></app-bar>
    <div class="live-body" @click="sendGroupLoveMsg">
      <!-- 直播前、直播中 -->
      <template v-if="!isLiveEnd">
        <div class="live-user">
          <div class="user-info">
            <div class="pic">
              <img
                :src="
                  getImageUrl(
                    user.logoUrl,
                    '?imageView2/1/w/60/h/60',
                    './static/img/header_user.png'
                  )
                "
              />
            </div>
            <div class="content">
              <h3>{{ user.nickName }}</h3>
              <p v-show="watchNum" v-if="live.isInteract">
                {{ watchNum }}人在此房间
              </p>
            </div>
          </div>
          <div class="user-list" v-if="live.isInteract">
            <template v-for="(item, index) in reverseWatchList">
              <div
                class="user-item"
                :key="`user_${item.openIdStr}`"
                v-if="index < maxShowWatchCount"
                :style="`z-index:${maxShowWatchCount - index}`"
              >
                <img
                  :src="
                    getImageUrl(
                      item.logoUrl,
                      '?imageView2/1/w/60/h/60',
                      './static/img/header_user.png'
                    )
                  "
                />
              </div>
            </template>
          </div>
        </div>
        <div class="live-video" ref="videoWrapper">
          <div
            class="video-wrap"
            :style="{
              'padding-top': live && live.screenOrientation == 1 ? '60px' : '0',
            }"
          >
            <video
              :style="{
                width: '100%',
                height:
                  live && live.screenOrientation == 1
                    ? 'calc(100vw * 9 / 16)'
                    : '100%',
                'max-height': '100%',
              }"
              class="tc-video"
              id="player-container-id"
              preload="auto"
              playsinline
              webkit-playsinline
            ></video>
          </div>
          <!-- 导览 -->
          <div
            class="select-guide"
            v-if="selectGuide"
            @click="guideScrollToItem(selectGuide.dataId)"
          >
            <div class="pic">
              <img
                :src="
                  getImageUrl(selectGuide.logoUrl, '?imageView2/1/w/66/h/66')
                "
              />
            </div>
            <div class="content">{{ selectGuide.title }}</div>
          </div>
          <div class="live-loading" v-if="loading"></div>
        </div>
        <template v-if="live.isInteract">
          <div v-if="token" class="live-main">
            <div class="message" ref="messageScroll">
              <live-message
                :datas="messageList"
                @update="updateMessage"
              ></live-message>
            </div>
            <div class="tools">
              <div class="like-flower">
                <like-animation ref="likeAnimation"></like-animation>
              </div>
              <div class="inner">
                <div
                  class="btn-guide"
                  v-if="guideList.length"
                  @click="isShowGuide = true"
                >
                  <span class="num">{{ guideList.length }}</span>
                </div>
                <input
                  type="text"
                  class="text"
                  placeholder="跟主播互动吧～"
                  v-model="messageText"
                  @keyup.enter="sendMsg"
                  @focus="inputFocus"
                  @blur="inputBlur"
                  ref="sendText"
                />
                <span class="flower" @click="sendGroupLoveMsg"></span>
                <input
                  type="button"
                  class="btn btn-send"
                  value="发送"
                  @touchstart="sendMsg"
                />
              </div>
            </div>
          </div>
          <div v-else class="live-main">
            <div class="tools">
              <div @click="getUserInfo" class="inner">
                <input
                  type="text"
                  class="text"
                  :disabled="true"
                  placeholder="去登录和主播互动吧"
                />
                <span class="flower"></span>
              </div>
            </div>
          </div>
        </template>
      </template>
      <!-- 直播结束 -->
      <template v-else>
        <!-- 直播结束有回放 -->
        <template v-if="hasPlayBack && detail">
          <div class="live-video-back" ref="videoWrapper">
            <video
              webkit-playsinline
              playsinline
              autoplay
              controls
              ref="player"
              id="player"
              @click="play"
              :src="
                detail.tapeMp4PlayUrl
                  ? detail.tapeMp4PlayUrl
                  : detail.tapePlayUrl
              "
            >
              <p>你的浏览器不支持HTML5 Video元素。</p>
            </video>
            <div class="live-loading" v-if="loading"></div>
          </div>
        </template>
        <!-- 看到结束 -->
        <template v-else>
          <div class="live-end">
            <div class="live-end-user">
              <div class="pic">
                <img :src="user.logoUrl" />
              </div>
              <div class="content">
                <p>{{ user.nickName }}</p>
              </div>
            </div>
            <h2>直播结束啦</h2>
          </div>
        </template>
      </template>
    </div>
    <!-- 导览列表 -->
    <mt-popup v-model="isShowGuide" position="bottom" class="guide-popup">
      <div class="guide">
        <div class="hd">
          <div class="title">导览({{ guideList.length }})</div>
        </div>
        <div class="bd guide-scroll">
          <div
            class="guide-item"
            v-for="item in guideList"
            :key="item.dataId"
            @click="guideToPage(item.dataType, item.dataId)"
          >
            <div class="pic">
              <img
                :src="getImageUrl(item.logoUrl, '?imageView2/1/w/500/h/500')"
              />
            </div>
            <div class="content">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
// 方法
import Hls from "hls.js";
import Live from "@/utils/live";
import { getImageUrl } from "@/utils/utils";
import { share } from "@/utils/share";
import Cookies from "js-cookie";
// 接口
import { getTokenUser } from "@/api/base";
import { getLive, getLiveSig } from "@/api/live";
// 组件
import AppBar from "@/components/AppBar";
import LiveMessage from "./LiveMessage";
import LikeAnimation from "./LikeAnimation";

export default {
  name: "LiveRoom",
  components: { AppBar, LiveMessage, LikeAnimation },
  metaInfo() {
    return { title: this.live.title };
  },
  data() {
    return {
      pid: "",
      isVerticalLive: true, // 竖屏直播
      isHorizontalLive: false, // 横屏直播
      isLiveEnd: false, // 直播结束
      isAfterLiveEntry: false, // 主播准备中
      isBeforeLiveLeave: false, // 主播离开了
      isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(
        navigator.userAgent
      ), // 移动端
      // isMobile: false, // 移动端
      isFocus: false,
      live: {}, // 直播信息
      user: {}, // 主播信息
      watchList: [], // 观看列表
      maxShowWatchCount: 5, // 最多显示5个用户头像
      watchNum: 0, // 观看人数
      messageList: [], // 消息列表
      maxShowMessageCount: 100, // 最多显示100条消息
      newLive: null,
      loginUser: {}, // 登录用户信息
      messageText: "",
      isLogin: false,
      userSig: "",
      hasPlayBack: false, // 是否回放
      player: null,
      hlsPlayer: null,
      liveUrl: "",
      reloadTimer: null,
      scrollTimer: null,
      loading: false,
      guideList: [], // 导览列表
      selectGuideId: null, // 当前选中的导览ID
      isShowGuide: false, // 是否显示导览列表
      doNotLogin: false, //是否需要登陆
      token: "",
      log: "",
      showPlayBtn: false,
      tcPlayer: null,
      detail: null,
      videoWidth: null,
      videoHeight: null,
    };
  },
  computed: {
    liveClass() {
      return {
        "is-verticalLive": this.isVerticalLive, // 竖屏
        "is-horizontalLive": this.isHorizontalLive, // 横屏
        "is-afterLiveEntry": this.isAfterLiveEntry, // 主播准备中
        "is-beforeLiveLeave": this.isBeforeLiveLeave, // 主播离开
        "is-playBack": this.hasPlayBack, // 回放
        "is-liveEnd": this.isLiveEnd, // 直播结束
        "is-focus": this.isMobile && this.isFocus,
      };
    },
    reverseWatchList() {
      return this.watchList.slice(0).reverse();
    },
    // 选中的导览
    selectGuide() {
      return this.guideList.find((item) => {
        return item.dataId === this.selectGuideId;
      });
    },
  },
  methods: {
    getImageUrl,
    // 获取直播信息
    getLive() {
      return getLive({ id: this.pid }).then((response) => {
        return response.data;
      });
    },
    // 直播间初始化
    liveRoomInit() {
      debugger;
      this.token = Cookies.get("token");
      this.getLive().then((response) => {
        // debugger
        let detail = response.info;
        this.detail = detail;
        if (detail.liveData.isExpanse && !detail.hasBuy) {
          // 未购买跳转详情页
          location.href = `${process.env.VUE_APP_SHARE_URL}/live.html?id=${this.pid}`;
          return false;
        }
        this.doNotLogin = !!response.info.liveData.doNotLogin;

        // 主播信息
        this.user = Object.assign({}, detail.userDetailInfo);
        // 直播信息
        this.live = Object.assign({}, detail.liveData);
        // 是否竖屏直播
        this.isVerticalLive = !this.live.screenOrientation;
        // 是否横屏直播
        this.isHorizontalLive = !!this.live.screenOrientation;

        this.liveUrl = this.live.hlsPlayUrl;

        if (this.live.roomStatus === 0) {
          // 未开始
          // 设置主播准备中
          this.isAfterLiveEntry = true;
          debugger;
        } else if (this.live.roomStatus === 1) {
          // 直播中
          // 没有直播信号，设置主播准备中
          // this.isAfterLiveEntry = true;
        } else if (this.live.roomStatus === 3) {
          debugger;
          this.isLiveEnd = true;
          // 已结束
          if (detail.tapeMp4PlayUrl) {
            this.liveUrl = detail.tapeMp4PlayUrl;
          } else {
            this.liveUrl = detail.tapePlayUrl;
          }

          if (this.liveUrl) {
            this.hasPlayBack = true;
          }
        }
        // 直播未结束，都可以加入群聊
        if (this.live.roomStatus !== 3 && this.token) {
          this.getUserInfo();
        } else if (this.live.roomStatus !== 3 && !this.doNotLogin) {
          this.getUserInfo();
        }
        this.$nextTick(function () {
          // 视频初始化
          if (!this.doNotLogin && this.token) {
            this.initVideo();
          } else if (this.doNotLogin) {
            this.initVideo();
          }
        });
        // 分享语
        share(response.share);
      });
    },
    // 获取用户信息
    getUserInfo() {
      getTokenUser().then((response) => {
        this.isLogin = true;
        this.loginUser = Object.assign({}, response.data);
        this.liveSDKInit();
      });
    },
    // 获取userSig
    getLiveSig() {
      return getLiveSig().then((response) => {
        this.userSig = response.data.sig;
      });
    },
    // 直播初始化
    liveSDKInit(userSig) {
      this.getLiveSig().then(() => {
        let loginInfo = {
          sdkAppID: process.env.VUE_APP_TCIMSDK_APPID, // 用户所属应用id,必填
          appIDAt3rd: process.env.VUE_APP_TCIMSDK_APPID, // 用户所属应用id，必填
          accountType: process.env.VUE_APP_TCIMSDK_ACCOUNT_TYPE, // 用户所属应用帐号类型，必填
          identifier: this.loginUser.openIdStr, // 当前用户ID,必须是否字符串类型，选填
          identifierNick: this.loginUser.nickName, // 当前用户昵称，选填
          userSig: this.userSig, // 当前用户身份凭证，必须是字符串类型，选填
          headurl: this.loginUser.logoUrl, // 当前用户默认头像，选填
        };
        // 初始化IMSDK
        this.newLive = new Live({
          avLiveRoomId: this.live.id,
          avLiveUserId: this.live.liveUid,
          avChatRoomId: this.live.groupId,
          loginInfo,
          onReady: () => {
            // 获取用户列表
            this.newLive.fetchGroupMemberList().then((response) => {
              if (response.code === 1) {
                let data = response.data;
                // 观看人数
                this.watchNum = data.totalCount;
                // 观看人数列表
                this.watchList = [...data.data, ...this.watchList];
              }
            });
            // 获取导览列表
            this.newLive.fetchGuideList().then((response) => {
              if (response.code === 1 && response.data.data.length) {
                this.guideList = response.data.data;
                this.selectGuideId = response.data.selectDataId;
              }
            });
          },
          // 消息通知
          onBigGroupMsgNotifyCallback: (msg) => {
            this.newLive.handlerMsg(msg, (newMsg) => {
              switch (newMsg.userAction) {
                case 2:
                  // 加入直播间
                  this.watchNum++;
                  this.updateWatchUserList(newMsg, true);
                  break;
                case 3:
                  // 退出直播间
                  if (this.watchNum >= 1) {
                    this.watchNum--;
                  }
                  this.updateWatchUserList(newMsg, false);
                  break;
                case 1001:
                  // 主播开始推流
                  // this.isAfterLiveEntry = false;
                  // this.isBeforeLiveLeave = false;
                  setTimeout(() => {
                    //怎么load  都不好使 ，这里需要重新刷新当前网页
                    location.reload();
                  }, 10000);
                  break;
                case 1002:
                  // 主播关闭直播推流
                  this.isBeforeLiveLeave = true;
                  // this.destroyVideo();
                  this.tcPlayer && this.tcPlayer.pause();
                  break;
                case 4:
                  // 点赞
                  this.$refs.likeAnimation.add();
                  break;
                case 1005:
                  // 添加导览消息
                  this.selectGuideId = JSON.parse(newMsg.msg).guideId;
                  break;
                case 1006:
                  // 清空导览消息
                  this.selectGuideId = null;
                  break;
              }
              this.messageList.push(
                Object.assign({}, newMsg, { isSend: msg.isSend })
              );
            });
          },
          // 系统消息通知
          onSystemMsgNotifyCallback: (msg) => {
            if (msg.ReportType === 5) {
              debugger;
              // 关闭直播间
              this.isLiveEnd = true;
              this.destroyVideo();
            }
          },
        });
        // 登录
        this.newLive.sdkLogin();
      });
    },
    updateMessage() {
      // 设置message的滚动条到底部
      this.$refs.messageScroll.scrollTop =
        this.$refs.messageScroll.scrollHeight -
        this.$refs.messageScroll.offsetHeight;
    },
    /**
     * data
     * type false减少；true增加
     */
    updateWatchUserList(data, type) {
      // 该用户是否存在
      let hasUserIndex = -1;
      for (let i = 0; i < this.watchList.length; i++) {
        let item = this.watchList[i];
        if (item.openIdStr === data.userId) {
          hasUserIndex = i;
        }
      }
      if (type) {
        // 添加用户
        // 如果用户存在先删除，后添加
        if (hasUserIndex >= 0) {
          this.watchList.splice(hasUserIndex, 1);
        }
        this.watchList.push({
          nickName: data.nickName,
          logoUrl: data.headPic,
          openIdStr: data.userId,
        });
      } else {
        // 删除用户
        if (hasUserIndex >= 0) {
          this.watchList.splice(hasUserIndex, 1);
        }
      }
    },
    // 聚焦
    inputFocus() {
      this.isFocus = true;
      this.scrollTimer && clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        document.body.scrollTop = document.body.scrollHeight;
      }, 300);
    },
    // 失去焦点
    inputBlur() {
      this.isFocus = false;
      this.scrollTimer && clearTimeout(this.scrollTimer);
      let height =
        document.documentElement.scrollTop || document.body.scrollTop || 0;
      window.scrollTo(0, Math.max(height - 1, 0));
    },
    // 发送消息
    sendMsg() {
      if (this.isLiveEnd) {
        return false;
      }
      this.checkUser(() => {
        if (this.messageText) {
          // userAction 1 文本消息
          this.newLive && this.newLive.sendMsg(1, this.messageText);
          this.messageText = "";
        } else {
          this.$toast("请输入消息内容");
        }
      });
    },
    // 发送点赞消息
    sendGroupLoveMsg() {
      if (this.isLiveEnd || !this.token) {
        return false;
      }
      this.checkUser(() => {
        this.newLive && this.newLive.sendGroupLoveMsg();
      });
    },
    // 校验用户
    checkUser(callback) {
      if (this.isLogin) {
        callback && callback();
      } else {
        this.getUserInfo();
      }
    },
    // 视频初始化
    initVideo() {
      if (this.isLiveEnd) {
        window.wx.ready(function () {
          let player = document.querySelector("#player");
          player && player.play();
        });

        this.loading = true;
      } else {
        // this.videoWidth = this.live.screenOrientation == 0 ? 540 : 960;
        // this.videoHeight = this.live.screenOrientation == 0 ? 960 : 540;
        // if (this.isMobile && this.live.screenOrientation == 1) {
        //   this.videoHeight = (document.body.clientWidth * 540) / 960;
        // } else {
        //   this.videoWidth = document.body.clientWidth;
        // }
        this.tcPlayer = new TCPlayer("player-container-id", {
          width: this.videoWidth,
          height: this.videoHeight,
          autoplay: true,
          preload: true,
          // poster: this.live.imageUrl,
          controlBar: {
            volumePanel: false,
            playbackRateMenuButton: false,
          },
        });

        this.tcPlayer.on("play", (event) => {
          console.log("play", event);
          // this.showPlayBtn = false;
          this.reloadTimer && clearInterval(this.reloadTimer);
        });
        this.tcPlayer.on("canplay", (event) => {
          console.log("canplay", event);
          this.playAction();
        });
        this.tcPlayer.on("error", (event) => {
          // this.isAfterLiveEntry = true;
          this.reloadVideo();
          console.log("video play error", event);
        });
        this.tcPlayer.src(this.live.hlsPlayUrl);
        window.wx.ready(() => {
          this.playAction();
        });
      }
    },
    playAction() {
      this.tcPlayer && this.tcPlayer.play();
    },

    // 视频事件处理
    videoEventHandler(event) {
      if (!event) return;
      this.log = event.type;

      if (
        this.tcPlayer &&
        (event.type === "seeked" || event.type === "loadedmetadata")
      ) {
        this.isAfterLiveEntry = false;
        this.isBeforeLiveLeave = false;
      }
      if (this.tcPlayer && event.type === "canplay") {
        this.playAction();
      }
      if (this.tcPlayer && event.type === "progress") {
        this.loading = false;
        this.isAfterLiveEntry ? (this.isAfterLiveEntry = false) : "";
        this.isBeforeLiveLeave ? (this.isBeforeLiveLeave = false) : "";
        //  this.log = this.tcPlayer.playing()
        if (!this.tcPlayer.playing()) {
          this.showPlayBtn = true;
        }
      }

      if (this.tcPlayer && event.type === "abort") {
        // this.isBeforeLiveLeave = true
      }
      if (this.tcPlayer && event.type === "error") {
        // this.$toast("视频加载失败，请稍后重试或刷新页面");
        this.isAfterLiveEntry = true;
        this.reloadVideo();
        console.log("video play error", event);
      } else {
        this.reloadTimer && clearInterval(this.reloadTimer);
      }
    },
    // 重新加载视频
    reloadVideo() {
      this.reloadTimer && clearInterval(this.reloadTimer);
      this.reloadTimer = setInterval(() => {
        this.playAction();
      }, 5000);
    },
    destroyVideo() {
      this.tcPlayer && this.tcPlayer.dispose();
    },
    // 导览页面跳转
    guideToPage(dataType, dataId) {
      let urlMap = {
        1: `${process.env.VUE_APP_SHARE_URL}/showSet.html?id=${dataId}`,
        2: `${process.env.VUE_APP_SHARE_URL}/show.html?id=${dataId}`,
        3: `${process.env.VUE_APP_SHARE_URL}/work.html?id=${dataId}`,
        4: `${process.env.VUE_APP_SHARE_URL}/jigouEntry.html?id=${dataId}`,
        7: `${process.env.VUE_APP_SHARE_URL}/notes.html?id=${dataId}`,
        8: `${process.env.VUE_APP_SHARE_URL}/channel.html?id=${dataId}`,
        9: `${process.env.VUE_APP_SHARE_URL}/activity.html?id=${dataId}`,
        10: `https://img.zai-art.com/${dataId}.html`, // 文章
        18: `${process.env.VUE_APP_SHARE_URL}/ask.html?id=${dataId}`,
        103: `${process.env.VUE_APP_SHARE_URL}/video.html?id=${dataId}`,
        31: `${process.env.VUE_APP_LOCATION_URL}/#/shop/item?id=${dataId}`, // 商品
      };
      if (urlMap[dataType]) {
        location.href = urlMap[dataType];
      }
    },
    // 点击当前选中的导览，滚到对应位置
    guideScrollToItem(dataId) {
      let scrollTop = 0;
      let guideScroll = document.querySelector(".guide-scroll");
      this.isShowGuide = true;
      this.guideList.forEach((item, index) => {
        if (item.dataId === dataId) {
          scrollTop = index * 121;
        }
      });
      // 设置滚到距离
      this.$nextTick(function () {
        guideScroll.scrollTop = scrollTop;
      });
    },
  },
  created() {
    this.pid = this.$route.query.id || this.$route.params.id;
  },
  mounted() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // We listen to the resize event
    window.addEventListener("resize", () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      console.log(vh);
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });

    //-----------------------

    this.liveRoomInit();
    document.querySelector("body").addEventListener("touchstart", (e) => {
      if (document.querySelector(".tools") !== e.target && this.isFocus) {
        this.$refs.sendText.blur();
      }
    });
  },
  beforeDestroy() {
    // 退出直播间
    this.newLive && this.newLive.logout();
    // 销毁
    this.destroyVideo();
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  beforeRouteLeave(to, from, next) {
    debugger;
    // 退出直播间
    this.newLive && this.newLive.logout();
    // 销毁
    this.destroyVideo();
    // this.tcPlayer && this.tcPlayer.pause();
    next();
  },
};
</script>
<style src="@/assets/css/live.css"></style>
<style>
.video-wrap {
  height: 100%;
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: row;
}
.vjs-errors-dialog {
  top: 60px;
  left: 30px;
  bottom: 60px;
  right: 30px;
  width: auto;
  height: auto;
}
</style>
